<template>
  <div class="privacy" v-loading.fullscreen="isLoading">
    <div v-if="remoteContent" v-html="remoteContent"></div>
    <section v-else-if="lang === 'en-US'" class="en-us-box">
      <p>Updated on: December 31, 2021<br />Effective on: January 7, 2022</p>
      <p>
        Beijing Jingdong 360 Degree Electric Commerce Co., Ltd. (“we”) values
        the protection of privacy and personal information of users. We may
        collect and use your relevant information when you use our products
        and/or services. We wish to show you through the
        <em>Privacy Policy for CIFTIS Digital Platform</em> (“the Privacy
        Policy”) how do we collect, use, store, share and transfer your
        information when you use our products and/or services, and the ways we
        provide you to access, update, delete and protect such information. This
        policy will help you understand the following:
      </p>
      <ol>
        <li>Scope of Application</li>
        <li>Scope of Your Information Collected by Us</li>
        <li>How Do We Collect Your Information</li>
        <li>
          How Do We Share, Transfer and Publicly Disclose Your Personal
          Information
        </li>
        <li>How Do We Protect and Save Your Personal Information</li>
        <li>How Do You Manage Your Personal Information</li>
        <li>Protection for Information of Minors</li>
        <li>Notice and Modification</li>
        <li>How to Contact Us</li>
      </ol>
      <p>
        <strong
          >The Privacy Policy is closely related to the services provided by us
          (or “CIFTIS Platform”) and the various business functions included in
          the services (hereinafter collectively referred to as “our products
          and/or services"). We hope that you have carefully read the Privacy
          Policy before using our products and/or services and confirm that you
          have fully understood the contents of the Policy, and that you can
          make your appropriate choices in accordance with the guidelines of the
          Privacy Policy.</strong
        >
        <strong
          >For the relevant terms involved in the Privacy Policy, we try our
          best to express them concisely and provide links for further
          explanations so that you can better understand them.</strong
        >
        <strong
          >If you use or continue to use our products and/or services after we
          update the Privacy Policy (we will prompt you about the update), it
          means that you agree to the contents of the Privacy Policy (including
          updated versions), and agree that we can collect, use, store and share
          your relevant information in accordance with the Privacy
          Policy.</strong
        >
        <strong
          >If you have any questions about the Privacy Policy or related
          matters, you can contact us at any time by sending an email to
          <a
            href="mailto:service@ciftis.org.cn"
            data-mce-href="mailto:service@ciftis.org.cn"
            >service@ciftis.org.cn</a
          >
          or calling our consulting hotline 400-693-0616.</strong
        >
      </p>
      <ol>
        <li><strong></strong> <strong>Scope of Application</strong></li>
      </ol>
      <p>
        1.1&nbsp; The Privacy Policy is applicable to all services of the CIFTIS
        Digital Platform, including the page browsing and website login services
        provided to you by the official website of CIFTIS (domain name:
        <a href="http://www.ciftis.org" data-mce-href="http://www.ciftis.org"
          >www.ciftis.org</a
        >) and the client of the CIFTIS Digital Platform, as well as the
        technical services provided to you through the website of the CIFTIS
        Digital Platform.
      </p>
      <p>
        1.2&nbsp; The Privacy Policy is not applicable to the services provided
        to you by other third parties through the website of the CIFTIS Digital
        Platform (collectively referred to as “third-party services”). The
        Privacy Policy is not applicable to the information you provide to
        third-party service providers. You should fully understand the product
        functions and privacy protection policies of the third-party services
        before choosing to use the third-party services, and then choose whether
        to activate the functions.
      </p>
      <p>
        1.3&nbsp; In particular, if you, as a user of the CIFTIS Digital
        Platform, serve your users with our technical services, you should
        separately agree a corresponding privacy policy with your users as your
        business data belongs to you.
      </p>
      <ol>
        <li>
          <strong></strong>
          <strong>Scope of Your Information Collected by Us</strong>
        </li>
      </ol>
      <p>
        The personal information involved in the Privacy Policy includes:
      </p>
      <p>
        Basic information: Information of your true, legal, and valid name,
        nationality, gender, date of birth, phone number, email address,
        position, and health code status at Health Kit APP submitted by you to
        complete the account registration, management, and real-name
        authentication on the CIFTIS Digital Platform;
      </p>
      <p>
        Personal identity information: Information of your ID card, passport,
        home visit permit, or mainland travel permit for Taiwan residents
        submitted by you when you use the services of the CIFTIS Digital
        Platform, such as badge application and visit appointment.
      </p>
      <p>
        Network ID information: Including system account, password, IP address,
        and email address.
      </p>
      <p>
        Personal browsing records: Website browsing records, software usage
        records, and log information; used to provide you with content
        recommendations and by the Organizing Committee for data statistics and
        analysis.
      </p>
      <p>
        Information of personal common device: Information describing the basic
        situation of personal common device, including hardware model, operating
        system type, and IDFA.
      </p>
      <p>
        Personal sensitive information refers to personal information that, once
        leaked, illegally provided, or misused, may endanger personal and
        property safety, and easily lead to loss of personal reputation,
        physical and mental health damages, or discriminatory treatment, etc.
        The personal sensitive information involved in the Privacy Policy
        includes: personal identity information (including ID card, passport,
        home visit permit, and mainland travel permit for Taiwan residents);
        network identification information (including account name, email
        address and passwords related to the foregoing); other information
        (including personal phone number, mobile phone number, and web browsing
        history records).
      </p>
      <ol>
        <li>
          <strong></strong>
          <strong
            >You can choose whether to authorize us to collect and use your
            personal information.</strong
          >
        </li>
      </ol>
      <p>
        <strong
          >If you do not provide such personal information, you can still browse
          our products and/or services, but you may not be able to use our
          products and/or services, mainly including:
        </strong>
      </p>
      <ol>
        <li>
          <strong></strong>
          <strong
            >If you do not provide your mobile phone number, account
            registration will not be possible, and some operations that require
            a mobile phone verification code to confirm the user's identity
            cannot be performed, such as retrieving the password and obtaining
            the notice of participation approval.</strong
          >
        </li>
        <li>
          <strong></strong>
          <strong
            >If you do not perform personal real-name authentication (you need
            to provide your name, ID card number, or certificates of residents
            of Hong Kong, Macao or Taiwan, passport number, and facial photo),
            badge application, visit appointment or intent contracting will not
            be possible.</strong
          >
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the Android or iOS CIFTIS App, you can enable the
            notifications to allow us to access to device ID and receive our
            message push, so as to obtain platform notifications, business talks
            messages, live notifications, conference notifications, etc. in a
            timely manner. If you do not enable this permission, you will not be
            able to get the latest data.</strong
          >
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the Android or iOS CIFTIS App, you need to allow to
            connect to the Internet to use our products and services. If you do
            not enable this permission, you will not be able to get the latest
            data.</strong
          >
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the scan, cloud conference, negotiation room, and
            real-name authentication functions on the Android or iOS CIFTIS App,
            you can allow the access to the camera to take real-time shooting
            and upload pictures. In scenarios that require face recognition, you
            need to call your camera to take face shots to allow us to access to
            your photos for real-name authentication, so as to facilitate the
            visit application and admission for the CIFTIS. If you do not allow
            the access, you will not be able to use the functions related to
            picture and visit application, but it does not affect your use of
            other services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the scan, negotiation room, and business card QR code
            functions on the Android or iOS CIFTIS App, you can allow the access
            to the album to upload pictures in the device. If you do not allow
            the access, you will not be able to use the functions related to
            picture uploading, but it will not affect your use of other
            services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the negotiation room or cloud conference services on
            the Android or iOS CIFTIS App, you can allow the access to the
            microphone to allow us to access to your voice content, hold to talk
            to describe the problem, send voice message, and allow the host to
            record video conference content. If you do not allow the access, you
            will not be able to use voice input related functions, but it will
            not affect your use of other services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use scan, negotiation room, cloud signing, cloud
            conference on the Android or iOS CIFTIS App, you can allow to save
            to use or save pictures or files. If you do not enable this
            permission, you will not be able to use functions related to memory
            card reading, but it will not affect your use of other services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the weather, AI navigation, and intelligent customer
            service functions on the Android or iOS CIFTIS App, you can allow
            the access to your location, so that we can push weather information
            and provide navigation services for you. If you do not enable this
            permission, you will not be able to use real route navigation and
            weather-related functions, but it will not affect your use of other
            services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the AI navigation and cloud conference functions on
            the Android or iOS CIFTIS App, you can allow the access to Bluetooth
            of the device to obtain indoor navigation services. If you do not
            allow the access, you will not be able to use indoor navigation
            related functions, but it will not affect your use of other
            services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the intelligent customer service and cloud conference
            functions on the Android or iOS CIFTIS App, you can allow the access
            to phone to obtain calls services. If you do not allow the access,
            you will not be able to use the functions related to calls, but it
            will not affect your use of other services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong
            >When you use the cloud conference function on the Android or iOS
            CIFTIS App, you can allow the access to contacts to obtain call list
            query service. If you do not allow the access, you will not be able
            to use the functions related to calls, but it will not affect your
            use of other services.
          </strong>
        </li>
        <li>
          <strong></strong>
          <strong>How Do We Collect Your Information</strong>
        </li>
      </ol>
      <p>
        <strong>4.1</strong>&nbsp;&nbsp;
        <strong
          >You apply to become a member of the CIFTIS Digital Platform</strong
        >
      </p>
      <p>
        <strong>4.1.1</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >When you create an account on the website of the CIFTIS Digital
          Platform, we will collect the information of your name you submit,
          your mobile phone number in the People’s Republic of China, and the
          account you set up.</strong
        >
        The mobile phone number you submit is used to accept the verification
        code when you register, log in, bind your account, and retrieve your
        password, and used to receive related business notices (such as
        exhibition information and service notices) as one of the contact
        methods designated by you.
        <strong
          >For an enterprise user, you also need to provide enterprise name,
          industry and registered address information.</strong
        >
      </p>
      <p>
        <strong>4.1.2</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >After you register your account on the CIFTIS Digital Platform, as an
          individual user, you can perform real-name authentication during the
          visit appointment process. You need to provide your name and ID card
          number when verifying your real name, and facial photos will be
          collected for domestic personnel.</strong
        >
        <strong
          >As an enterprise user, you can apply for participation in the
          exhibition in the Account Center and provide corresponding
          information, including (i) contact information (name, position, phone
          number, and email address), (ii) enterprise information (name, nature,
          social credit code, industry, registration address, type, website, and
          introduction); among them, the category (i) enterprise information you
          provide will be used by the Organizing Committee to contact you to
          communicate information about participation in the exhibition and to
          display it to other enterprises for further communication and
          negotiation with you.</strong
        >
        <strong
          >Such information you submit is only used for visit appointment or
          enterprise participation application for China International Fair for
          Trade in Services ("CIFTIS" for short).</strong
        >
        <strong
          >If you do not provide such information, it will not affect your use
          of other services of the CIFTIS Platform.</strong
        >
      </p>
      <p>
        <strong>4.1.3</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >When creating a sub-user under your account, you need to collect the
          name, mobile phone number, email address, nationality, gender, ID card
          number, date of birth, position, and badge photo of the sub-user
          principal</strong
        >
        <strong
          >The personal information of the sub-user you submit is deemed to have
          been authorized by the sub-account subject and you are authorized to
          submit the above-mentioned information of the sub-account.</strong
        >
      </p>
      <p>
        <strong>4.1.4</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >If you only need to use basic services such as browsing and
          searching, you do not need to register as our member and provide the
          above information.</strong
        >
      </p>
      <p>
        <strong>4.1.5</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >If you have already registered an account on the CIFTIS Digital
          Platform, you can log in to the website of the CIFTIS Digital Platform
          with the aforementioned account.</strong
        >
        <strong
          >When you log in to the website with the account registered, the
          real-name registration information (name/enterprise name, ID card
          number/business license number, mobile phone number/email address) of
          the aforesaid account will be synchronized to the CIFTIS Digital
          Platform.</strong
        >
      </p>
      <p>
        <strong>4.2</strong>&nbsp;&nbsp;
        <strong
          >You use the services available on the CIFTIS Digital Platform</strong
        >
      </p>
      <p>
        <strong>4.2.1</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >When you use the services available on the CIFTIS Digital Platform,
          you should provide your real identity information to complete the
          real-name authentication. During this process, you will submit your
          name (entity name), ID card number (business license number),
          enterprise registration address, enterprise nature, enterprise name
          and business license registration number, and enterprise contact
          information</strong
        >
      </p>
      <p>
        <strong>4.2.2</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >We will receive and record the relevant information about the device
          you use (such as device model, operating system version, device
          settings and other software and hardware characteristics), and
          information about the location of the device (IP address) according to
          the specific permissions granted by you during software installation
          and use.</strong
        >
        <strong
          >We may associate the first two types of information so that we can
          provide you with consistent services on different devices.</strong
        >
      </p>
      <p>
        <strong>4.2.3</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >When you use the services provided by our website or client, we will
          automatically collect the information of your use of our services and
          save such information as relevant web logs in order to identify
          account abnormality, understand the suitability of the products, and
          help the hosts optimize the exhibits display forms in the exhibition
          and live streaming effect.</strong
        >
        <strong>Including:</strong>
      </p>
      <p>
        <strong
          >Equipment information: We will receive and record the relevant
          information about the equipment you use (including equipment model,
          operating system version, and software and hardware characteristics
          such as unique device identifier), and information about the location
          of the equipment (including your authorized GPS location, WLAN access
          points, Bluetooth, base stations and other sensor information)
          according to your specific operations during software installation
          and/or use.</strong
        >
      </p>
      <p>
        <strong
          >Service log information: When you use the products or services
          provided by our website or client, we will automatically collect the
          information of your detailed use of our services and save it as a
          service log, for example, search and query contents, IP address,
          browser type, telecommunications operator, language used, date and
          time of visit, and records of web pages visited.</strong
        >
      </p>
      <p>
        <strong>4.2.4</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >Please note that such information as individual device information
          and log information is the information that cannot identify a specific
          natural person.</strong
        >
        <strong
          >If we combine this type of information with other information to
          identify a specific natural person, or combine it with personal
          information, this type of information will be treated as personal
          information during the combined use, and we will de-identify this type
          of personal information unless it is authorized by you or otherwise
          provided by laws and regulations.</strong
        >
      </p>
      <p>
        <strong>4.2.5</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >User account support information: Based on the user’s consultation
          record, fault report record and troubleshooting process for user’s
          faults (such as communication or call records) generated by your use
          of the services available on the CIFTIS Digital Platform, we will
          record and analyze the information in order to respond to your
          requests for help in a timely manner and to improve services.</strong
        >
      </p>
      <p>
        <strong
          >In order to provide you with information display, search and push
          services that are more convenient and more compliant with your
          individual needs, we will extract your preference characteristics and
          generate indirect crowd portraits based on the characteristic labels
          for display and push information and possible commercial
          advertisements base on your device information and your browsing and
          use information when your use the services of the CIFTIS
          Platform.</strong
        >
      </p>
      <p>
        <strong>We strive to ensure good browsing experience for you.</strong>
        <strong
          >If you do not want to receive the commercial advertisements that we
          send to you, you can reply to unsubscribe through SMS prompts or
          unsubscribe or close by other methods provided by us.</strong
        >
        <strong
          >In addition, we will also use your above information in order to
          continuously improve and optimize the above functions.</strong
        >
      </p>
      <p>
        <strong>4.3</strong>&nbsp;&nbsp;
        <strong
          >We may collect and use your information through cookies and other
          related technologies.</strong
        >
      </p>
      <p>
        <strong>4.3.1</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong>The specific purposes we use cookies include:</strong>
      </p>
      <p>
        <strong>To remember your identity.</strong>
        <strong
          >For example: Cookies help us identify you as our registered
          user.</strong
        >
      </p>
      <p>
        <strong
          >To analyze your use of our services in order to provide you with more
          thoughtful and personalized services, including customized pages,
          recommendations and other services.
        </strong>
      </p>
      <p>
        <strong>4.3.2</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >You can reject or manage cookies through your browser
          settings.</strong
        >
        <strong
          >However, please note that you may not be able to enjoy the best
          service experience, and the availability of certain functions may be
          affected if you disable cookies.</strong
        >
      </p>
      <p>
        <strong>4.3.3</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >The Privacy Policy will apply to the relevant information recorded
          through cookies.</strong
        >
      </p>
      <p>
        <strong>4.4</strong>&nbsp;&nbsp;
        <strong>We obtain your personal information from a third party</strong>
      </p>
      <p>
        We may obtain personal information that you have authorized to share
        from a third party, and after you agree to the Privacy Policy,
        <strong
          >we will use your personal information in compliance with relevant
          laws and regulations after confirming the legality of the sources of
          the personal information in accordance with the agreement with the
          third party.</strong
        >
      </p>
      <p>
        <strong>4.5 </strong>
        <strong
          >In order to facilitate the communication between buyers, hosts and
          exhibitors, employees, contact persons or other representatives of
          enterprise buyers and individual buyers can make business talks and
          inquiries through online conferences, instant messaging, station
          messages, forum messages, etc. on the CIFTIS Platform.</strong
        >
        <strong
          >If you want to use this function, you may need to provide us with
          your real name, personal ID information (ID card number, passport
          number, etc.) according to the management requirements of the
          real-name system, so that we can perform real-name
          authentication.</strong
        >
      </p>
      <p>
        <strong
          >For the above additional services, you can choose not to provide the
          personal information, but it will affect your normal use of the main
          functions of the CIFTIS services.</strong
        >
      </p>
      <p>
        <strong>4.6</strong>&nbsp;&nbsp;
        <strong
          >We will immediately stop continuing to collect your personal
          information when you terminate the use of our products and/or
          services, or after the expiration of the service term for your use of
          our products and/or services.</strong
        >
      </p>
      <ol>
        <li>
          <strong
            >How Do We Share, Transfer and Publicly Disclose Your Personal
            Information</strong
          >
        </li>
      </ol>
      <p>5.1&nbsp; Sharing</p>
      <p>
        5.1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We will not share your personal
        information with any other company, organization or individual, except
        that:
      </p>
      <p>(1) We have obtained your express consent or authorization;</p>
      <p>
        (2)&nbsp; We are required to provide your personal information in
        accordance with the applicable laws and regulations, legal proceedings,
        mandatory administrative or juridical requirements;
      </p>
      <p>
        (3)&nbsp; To the extent permitted by laws and regulations, it is
        necessary to provide your personal information so as to protect the
        interest, properties or security of us, our affiliates or partners, you
        or other users of the CIFTIS Digital Platform or the public;
      </p>
      <p>
        (4)&nbsp; We have to realize the core functions of our products and/or
        services or provide your required services only by sharing your
        information;
      </p>
      <p>
        (5)&nbsp; We deal with your disputes or controversies with others upon
        your request;
      </p>
      <p>
        (6)&nbsp; We share your personal information in accordance with the
        relevant agreements (including electronic agreements singed online and
        the corresponding platform rules) or other legal instruments to which
        you are a party;
      </p>
      <p>
        (7)&nbsp; We use your personal information to the public benefit in line
        with the laws and regulations.
      </p>
      <p>
        5.1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We may share your personal
        information with our affiliates to ensure the smooth provision of the
        services to you. But, we will only share necessary personal information
        subject to the purpose stated in the Privacy Policy. If our related
        parties have to change the processing purpose of the personal
        information, we will obtain your authorization and consent again.
      </p>
      <p>
        5.1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We might appoint partners to provide
        certain services, and have to share your user information with the
        partners, in order to successfully complete the services provided to
        you. However, we will share your personal information for legal, proper,
        necessary, specific and express purpose only, and will only share the
        personal information required for the services. Our partners have no
        right to use the shared personal information for any other purposes. At
        present, our partners include: suppliers, service providers and other
        partners. We will send the information to the suppliers, the service
        providers and other partners who support our business. Such support
        includes providing basic technical services, consulting, analysis and
        other professional services.
      </p>
      <p>
        5.1.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Software development kit (SDK) or
        other similar applications of the authorized partners will be embedded
        in our client (APP of the CIFTIS Digital Platform) so that you are able
        to use the aforesaid professional services.
      </p>
      <p>
        Third-party SDKs may be embedded in Android APP of the CIFTIS Digital
        Platform in the following cases:
      </p>
      <p><br /></p>
      <p><br /></p>
      <table class="confluenceTable">
        <tbody class="">
          <tr class="">
            <td class="confluenceTd">
              <p><strong>Description of Scenario </strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>Required Personal Information Field </strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>Name of Authorizing Organization </strong></p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>ShareSDK</p></td>
            <td class="confluenceTd"><p>Nickname, unique user ID</p></td>
            <td class="confluenceTd">
              <p>Shenzhen Tencent Computer Systems Company Limited</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>Huawei PUSH</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, system version, equipment model,
                equipment manufacturer
              </p>
            </td>
            <td class="confluenceTd">
              <p>Huawei Technologies Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>Meizu PUSH</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, system version, equipment model,
                equipment manufacturer
              </p>
            </td>
            <td class="confluenceTd">
              <p>Zhuhai Meizu Technology Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>MiPush</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, system version, equipment model,
                equipment manufacturer
              </p>
            </td>
            <td class="confluenceTd"><p>MI Technology Co., Ltd.</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>JD PUSH</p></td>
            <td class="confluenceTd">
              <p>
                Mobile phone status, ROM version, name of manufacturer, mobile
                phone model
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Jingdong Century Trade Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>JD Meridian</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, MAC address, equipment manufacturer,
                equipment model, system version, unit run time (URT), user
                access IP address, operation system, browser type, browser
                version, and unique browser number
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Jingdong Century Trade Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>JD EagleEye</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, MAC address, equipment manufacturer,
                equipment model, system version, memory space, memory size,
                network type,, URT, and internal page access records
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Jingdong Century Trade Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>Cloud Conference</p></td>
            <td class="confluenceTd">
              <p>
                Nickname, unique device identifier, system version, equipment
                model, equipment manufacturer, IP address, and Zoom SDK
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing CloudUnicomm Technology Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd">
              <p>Live video_ iFLYTEK SDK ASR and other features</p>
            </td>
            <td class="confluenceTd"><p>Nickname, unique user ID</p></td>
            <td class="confluenceTd"><p>IFLYTEK Co., Ltd.</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>AI Navigation</p></td>
            <td class="confluenceTd"><p>Nickname, unique user ID</p></td>
            <td class="confluenceTd">
              <p>Beijing FengMap Technology Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>Negotiation Room</p></td>
            <td class="confluenceTd">
              <p>
                Unique user ID, user organization logo, user ID, dialogue ID,
                and dialogue source
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Wodong Tianjun Information Technology Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>OPPO push</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, system version, equipment model,
                equipment manufacturer
              </p>
            </td>
            <td class="confluenceTd">
              <p>Guangdong OPPO Mobile Telecommunications Co., Ltd.</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Third-party SDKs may be embedded in IOS APP of the CIFTIS Digital
        Platform in the following cases:
      </p>
      <table class="confluenceTable">
        <tbody class="">
          <tr class="">
            <td class="confluenceTd">
              <p><strong>Description of Scenario </strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>Required Personal Information Field </strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>Name of Authorizing Organization </strong></p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>ShareSDK</p></td>
            <td class="confluenceTd"><p>Nickname, unique user ID</p></td>
            <td class="confluenceTd">
              <p>Shenzhen Tencent Computer Systems Company Limited</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>JD PUSH</p></td>
            <td class="confluenceTd">
              <p>
                Mobile phone status, ROM version, name of manufacturer, mobile
                phone model
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Jingdong Century Trade Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>JD Meridian</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, MAC address, equipment manufacturer,
                equipment model, system version, unit run time (URT), user
                access IP address, operation system, browser type, browser
                version, and unique browser number
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Jingdong Century Trade Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>JD EagleEye</p></td>
            <td class="confluenceTd">
              <p>
                Unique device identifier, MAC address, equipment manufacturer,
                equipment model, system version, memory space, memory size,
                network type,, URT, and internal page access records
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Jingdong Century Trade Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>Cloud Conference</p></td>
            <td class="confluenceTd">
              <p>
                Nickname, unique device identifier, system version, equipment
                model, equipment manufacturer, IP address, and Zoom SDK
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing CloudUnicomm Technology Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd">
              <p>Live video_ iFLYTEK ASR and other features</p>
            </td>
            <td class="confluenceTd"><p>Nickname, unique user ID</p></td>
            <td class="confluenceTd"><p>IFLYTEK Co., Ltd.</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>AI Navigation</p></td>
            <td class="confluenceTd"><p>Nickname, unique user ID</p></td>
            <td class="confluenceTd">
              <p>Beijing FengMap Technology Co., Ltd.</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>Negotiation Room</p></td>
            <td class="confluenceTd">
              <p>
                Unique user ID, user organization logo, user ID, dialogue ID,
                and dialogue source
              </p>
            </td>
            <td class="confluenceTd">
              <p>Beijing Wodong Tianjun Information Technology Co., Ltd.</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        5.1.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We will sign due nondisclosure
        agreements with any companies, organizations and individuals with whom
        we share the personal information, and will demand such companies,
        organizations and individuals to process the personal information based
        on our instructions, the Privacy Policy and any other relevant
        nondisclosure and security measures. In order to protect security and
        availability of the data in possession by a third party, we have
        launched TripodCloud which provides a safe and reliable environment for
        use and saving of data and protects security of the user’s data at the
        cloud terminal. In respect to use of sensitive personal data, we expect
        a third party to use the data desensitization and encryption technology
        to effectively protect the user’s data.
      </p>
      <p>
        5.1.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; In order to comply with laws,
        execute or apply our use conditions and other agreements, or in order to
        protect the rights and properties or safety of you or other customers of
        the CIFTIS Digital Platform, such as preventing fraud and other illegal
        activities and reducing credit risks, we will exchange information with
        other companies and organizations. However, sale, lease, sharing or
        otherwise disclosure of the personal information for making profits in
        violation of the commitments under the Privacy Policy is excluded.
      </p>
      <p>5.2&nbsp; Transfer</p>
      <p>
        We will not transfer your personal information to any companies,
        organizations and individuals, except that:
      </p>
      <p>
        5.2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We have obtained your express
        consent or authorization;
      </p>
      <p>
        5.2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We are required to do so by
        applicable laws and regulations, legal proceedings, mandatory
        administrative or juridical requirements;
      </p>
      <p>
        5.2.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We share your personal information
        in accordance with the relevant agreements (including electronic
        agreements singed online and the corresponding platform rules) or other
        legal instruments to which you are a party;
      </p>
      <p>
        5.2.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If transfer of personal information
        is involved in any transactions regarding merger, acquisition, asset
        transfer or similar issues, we will require the new companies and
        organizations in possession of your personal information to continue
        being bound by the Privacy Policy. Otherwise, we will require such
        companies and organizations to obtain your authorization and consent
        again.
      </p>
      <p>5.3&nbsp; Public Disclosure</p>
      <p>
        We will publish and disclose your personal information only in the
        following circumstances and subject to security measures in line with
        the industry standards:
      </p>
      <p>
        <strong>5.3.1</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >We will disclosure your designated personal information in such way
          expressly agreed by you based on your requirements;
        </strong>
      </p>
      <p>
        <strong>5.3.2</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <strong
          >We might disclose your personal information based on type and
          disclosure manner of the required personal information if we are
          required to do so by the laws, regulations, and mandatory
          administrative or juridical requirements. Subject to laws and
          regulations, when we receive the aforesaid request for disclosure of
          information, we will require production of corresponding legal
          instruments, such as court summons or letter of investigation.</strong
        >
        <strong
          >We firmly believe that any information that we are required to
          provide shall be maintained transparent as much as possible to the
          extent permitted by laws. We will carefully examine all requests, in
          order to ensure that such request has legal basis, and is only limited
          to the data rightfully obtained by the law-enforcing department for
          specific investigation purpose.
        </strong>
      </p>
      <ol>
        <li>
          <strong> </strong>
          <strong>How Do We Protect and Save Your Personal Information</strong>
        </li>
      </ol>
      <p>
        6.1&nbsp; Technology and measures for protection of your personal
        information. We attach great importance to security of the personal
        information, and take all reasonable and practical actions to protect
        your personal information;
      </p>
      <p>
        6.1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Data safety technical measures. We
        will take safety protection measures in line with the industry
        standards, including establishing reasonable systems, specifications and
        safety technology to prevent your personal information from any
        unauthorized access and revision, and avoid damage or loss of data. In
        respect of our network service, Transport Layer Security Protocol (TLSP)
        and other encryption technologies, as well as browser service via https
        have been used to protect security of the user’s data in the
        transmission process. We employ the encryption technology to save the
        user’s personal information in encrypted way, and uses the isolation
        technique for isolation of the information. While using the personal
        information, such as display of personal information, and personal
        information contextual computing, we will use a number of data
        desensitization technologies including content replacement and SHA256 to
        intensify security of personal information. We employ strict data access
        authority control and multiple authentication technologies to protect
        the personal information and avoid illegal use of the data. We employ
        code security automatic inspection and data access logo analysis
        technology to audit the personal information security.
      </p>
      <p>
        6.1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Other security measures taken to
        protect personal information
      </p>
      <p>
        We manage and regulate the saving and use of the personal information by
        establishing data classification system, data security management rules
        and data security development rules. We fully control the security of
        the data through the nondisclosure agreements, and monitoring and audit
        mechanism. Safety certification and service: We have received “Reliable
        Cloud” Certification issued by Data Center Alliance (DCA) in respect to
        the underlying cloud technology for saving of your personal data, have
        passed the Level-III Security Certification of the Ministry of Public
        Security, and have obtained ISO27001 Certification at the same time.
        Enhancement of safety awareness: We will also organize training courses
        regarding safety and privacy protection to enhance the employees’
        awareness in respect to importance to protect the personal information.
      </p>
      <p>
        6.1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We will only permit the employees
        and partners of us and our affiliates to access to the personal
        information on a need-to-know basis, and have set strict access
        authority control and monitoring mechanism. Meanwhile, we also require
        all personnel who might access to your personal information to fulfill
        corresponding confidentiality obligations. If they fail to fulfill such
        obligations, they might be held legally responsible or the cooperation
        relationship with us might be terminated.
      </p>
      <p>
        6.1.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We will take all reasonable and
        practical actions to guarantee not to collect any irrelevant personal
        information. We will retain your personal information during the period
        required for the purpose contemplated by the Privacy Policy only, unless
        the retention period shall be extended or it is permitted by laws.
      </p>
      <p>
        6.1.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Internet is not an absolutely safe
        environment at all, and it is impossible to ascertain that e-mail,
        instant message, social contact software and other communication ways
        with the user are fully encrypted. We suggest you setting complicated
        password when you use such tools, and properly protect security of your
        personal information.
      </p>
      <p>
        6.1.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The Internet environment is not
        absolutely safe at all. We will try our best to ensure or guarantee the
        security of any information you send to us. If our physical,
        technological or managerial protection facilities are damaged, giving
        rise to unauthorized access, disclosure, modification or destruction of
        the information, or prejudice to your legitimate rights and interest, we
        will assume legal liability accordingly.
      </p>
      <p>
        6.1.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Disposal of security incidents. It
        is unavoidable to disclose your personal information to the transaction
        counterparty or potential transaction counterparty, such as contact
        information or postal address when you exchange trade or services with a
        third party online at the website of the CIFTIS Digital Platform. You
        are expected to properly protect your own personal information, and make
        it available to others only if necessary.
      </p>
      <p>
        In order to respond to the possible risks of disclosure, destruction or
        loss of data, we have developed a number of systems to identify the
        security incidents, security bug classification criteria and
        corresponding response process. We have also established a special
        emergency response team for the security incidents, initiated the safety
        plan against different security incidents based on the security incident
        handling standards and requirements, stopped loss, analyzed and located
        incidents, developed remedies and worked together with the interested
        authorities to trace and eliminate the causes of the incidents. In case
        of security incidents involving personal information, we will inform you
        of the basic situation and possible impact of the security incident, the
        actions that we have taken or will take, recommendations that you may
        independently prevent and reduce the risks, and the remedies taken for
        you in time in accordance with the laws and regulations. Meanwhile, we
        will inform you of the relevant conditions related to the incident by
        mail, letter, phone or message. When it is hard to inform the subjects
        of the personal information one by one, we will take reasonable and
        effective way to make an announcement. Meanwhile, we will take the
        initiative to report disposal of the personal information security
        incident based on the requirements of the regulatory departments.
      </p>
      <p>
        6.1.8 &nbsp;&nbsp;&nbsp; If you have any questions about our personal
        information protection, you may contact us through the contact
        information at the bottom of the Policy. If you find any disclosure of
        your own personal information, in particular to your user name and
        password, please immediately contact us through the contact information
        stated in [Contact us] at the bottom of the Policy, so that we could
        take corresponding actions.
      </p>
      <p>6.2&nbsp; Saving of your personal information</p>
      <p>
        6.2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Your personal information will be
        fully saved in the territory of the People’s Republic of China. If you
        use cross-border transaction services, and has to transmit your personal
        information aboard in order to complete the transactions, we will
        individually obtain your authorization and consent, and demand the
        receiving party to process such personal information according to our
        instructions, the Privacy Policy and any other relevant confidentiality
        and security measures.
      </p>
      <p>
        6.2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; The “Notes for Cancellation of
        CIFTIS Digital Platform Account” set forth how to cancel your account
        and the conditions that you shall meet. After you cancel the account, we
        will stop providing any products and/or services to you, and except
        otherwise stipulated by laws and regulations, we will delete your
        personal information based on your requirements.
        <strong
          >Please note that after you successfully apply for canceling your
          account on the CIFTIS Digital Platform, we will examine and approve
          your request within 3 working days. After your request is approved, we
          will delete your personal information.
        </strong>
      </p>
      <p>
        6.2.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; If we terminate services or
        operation, we will give a notice to you at least 30 days in advance, and
        will delete or anonymize your personal information after termination of
        the services or operation.
      </p>
      <ol>
        <li>
          <strong> </strong>
          <strong>How Do You Manage Your Personal Information </strong>
        </li>
      </ol>
      <p>
        We value your attention to the personal information, and will do our
        best to protect your rights to access to, correct and delete your
        personal information and withdraw consent, so that you have full ability
        to protect your privacy and security. Your rights include:
      </p>
      <p>
        7.1&nbsp; You can log in to the management background of the CIFTIS
        Digital Platform website to query and manage (modify, delete) personnel
        information submitted when using the CIFTIS Digital Platform services.
      </p>
      <p>
        7.2&nbsp; If you have to revise your real name-authenticated information
        for the account on the CIFTIS Digital Platform, you have to contact us
        by work order or phone, and operate according to our operation
        documents; if you have to revise the real name-authenticated information
        submitted via the account of the CIFTIS Digital Platform, you have to
        visit the original website for registration of the account.
      </p>
      <p>
        7.3&nbsp; You may give a request to us to delete the user information
        if:
      </p>
      <p>
        7.3.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Our processing of the user
        information violates the laws and regulations;
      </p>
      <p>
        7.3.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; We collect and use your user
        information without your express consent;
      </p>
      <p>
        7.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Our processing of personal
        information has seriously violated the agreement with you;
      </p>
      <p>
        7.3.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; You withdraw or withhold consent;
      </p>
      <p>
        7.4&nbsp; You change the scope of your authorization or withdraw your
        authorization.
      </p>
      <p>
        You may contact us by work order or phone to change the scope of your
        authorization to us for continuing collection of personal information or
        withdraw your authorization. You may withdraw all authorization to us
        for continuing collection of your personal information by canceling the
        account.
      </p>
      <p>
        Please note that some basic personal information is essential to enable
        each business function. After you withdraw your consent or
        authorization, we are unable to continue providing the services
        corresponding to your withdrawn consent or authorization, and will cease
        to process your corresponding personal information. However, your
        decision to withdraw consent or authorization will not affect any
        previous processing of any personal information under your
        authorization.
      </p>
      <p>
        7.5&nbsp; In order to maintain and improve the services, and display
        information that better fits your personalized demand, we might combine
        the user information from certain service of the CIFTIS Digital Platform
        with the information from other services, to produce characteristic
        model and user profile, and display and push information to you,
        including but not limited to news and market activity information in
        relation to the products of the CIFTIS Digital Platform, promotion
        information of third-party partners, or other contents that you might be
        interested in.
        <strong
          >If you do not want to receive any electronic commercial information
          from us, you might cancel this service at any time in the following
          way:
        </strong>
      </p>
      <p>
        (1)&nbsp; We will work together with a third-party platform or media
        (each as “platform”) to recommend personalized exhibits to you based on
        your personal information. Such personal information includes shopping
        at this website, access to the websites of the affiliates of this
        website, etc. The platform is only a window for us to display the
        exhibits. The URLs of the window contents are used for displaying the
        personalized exhibit in the website of the CIFTIS Digital Platform, and
        are subject to our management. Thus, we will not provide any of your
        personal information to the advertising companies. If you are unwilling
        to accept the services we recommend in a platform, please contact the
        platform to disable the services. You acknowledge and understand that
        the platform is an entity of independent management, and is not subject
        to our management.
      </p>
      <p>
        (2)&nbsp; In order to protect your privacy, we will not send any
        promotion or commodity information involving religious faith, sex,
        disease and other sensitive information to you in any ways and through
        any channels.
      </p>
      <ol>
        <li>
          <strong> </strong>
          <strong>Protection of the Personal Information of the Minors </strong>
        </li>
      </ol>
      <p>
        8.1&nbsp; We attach great importance to protection of the personal
        information of the minors. If you are under the age of 18, you shall
        obtain written consent from your parents or statutory guardian before
        using our products and/or services. We will protect the personal
        information of the minors in accordance with the applicable national
        laws and regulations.
      </p>
      <p>
        8.2&nbsp; As to the personal information collected from the minors with
        consent of their parents or statutory guardian, we will use or disclose
        such information only with permit by laws, express consent of the
        parents or guardian or required for protection of the minor.
      </p>
      <p>
        8.3&nbsp; If we find that we have collected the personal information of
        the minors without prior consent of their parents or statutory guardian,
        we will try to delete the relevant data as soon as possible.
      </p>
      <ol>
        <li><strong>Notice and Modification</strong></li>
      </ol>
      <p>
        9.1&nbsp; With the development of our business, this Privacy Policy will
        be updated accordingly to provide you with better services. However, we
        will not reduce your rights under this Privacy Policy without your
        express consent. We will notify you of relevant updates by posting an
        updated version on the website of CIFTIS Digital Platform and making a
        website announcement before such updates take effect or by any other
        appropriate means. You may also visit the CIFTIS Digital Platform to
        keep abreast of the latest privacy policy.
      </p>
      <p>
        9.2&nbsp; For major changes, we will also provide notifications in more
        prominent ways (including, but not limited to, emails, text messages or
        special tips on our web pages) to explain the specific changes to the
        privacy policy. Major changes referred to in this Policy include but are
        not limited to: (a) major changes in our service model, such as the
        purpose of processing personal information, the type of personal
        information under processing, how the personal information will be used,
        etc.; (b) major changes in our ownership structure, organizational
        structure and other aspects, such as business adjustment, and change of
        owners caused by bankruptcy, mergers and acquisitions, etc.; (c) changes
        in the main objects of sharing, transfer or public disclosure of
        personal information; (d) major changes in your rights to participate in
        the processing of personal information and changes in the way such
        rights are exercised; (e) changes in our responsible department dealing
        with personal information security, contact details and complaint
        channels; (f) when it is indicated in the “Personal Information Security
        Impact Assessment Report” that there is a high risk.
      </p>
      <p>
        9.3&nbsp; The old versions of the Privacy Policy will be archived for
        your reference.
      </p>
      <ol>
        <li><strong>How to Contact Us</strong></li>
      </ol>
      <p>
        10.1 If you have any questions, comments or suggestions regarding this
        Privacy Policy or your personal information, please contact us by email
        to
        <a
          href="mailto:service@ciftis.org.cn"
          data-mce-href="mailto:service@ciftis.org.cn"
          >service@ciftis.org.cn</a
        >
        or by calling our customer service 400-693-0616.
      </p>
      <p>
        10.2 We have designated a specialist for personal information
        protection, whom you may contact by email to
        <a
          href="mailto:service@ciftis.org.cn"
          data-mce-href="mailto:service@ciftis.org.cn"
          >service@ciftis.org.cn</a
        >.
      </p>
      <p>
        10.3 Normally, we will reply you within 30 days. If you are not
        satisfied with our reply, especially if you think our way of processing
        your personal information harms your legitimate rights and interests,
        you may also complain the case or report it to the regulatory
        authorities of network information, telecommunications, public security,
        industry and commerce, etc.
      </p>
      <p><br /></p>
      <p>
        <strong
          >Attachment: Notes for Cancellation of CIFTIS Digital Platform
          Account</strong
        >
      </p>
      <p>
        Text of the Notes for Cancellation of CIFTIS Digital Platform Account:
      </p>
      <p>
        Upon cancellation of this account, you will waive the following rights,
        interests and assets
      </p>
      <ol>
        <li>The account information cannot be recovered.</li>
        <li>
          You will not be able to log into CIFTIS Digital Platform service by
          use of the originally verified mobile phone number or email address of
          the account.
        </li>
        <li>
          The authorization or binding relationship with the third party will be
          terminated.
        </li>
      </ol>
      <p>
        You understand and agree that CIFTIS Digital Platform cannot assist you
        in restoring the aforementioned services; your behavior of cancelling
        your account will cause much inconvenience to your after-sales rights
        protection. Therefore, before any operation, please make sure that your
        account is free from any disputes, back up all information and data
        related to your CIFTIS system account, and download and save the
        transaction vouchers, electronic contracts and other documents related
        to the ordered products or services; otherwise, CIFTIS Digital Platform
        will not be able to assist you in obtaining the above information.
      </p>
      <p>
        <strong
          >Notes for Cancellation of CIFTIS Digital Platform Account</strong
        >
      </p>
      <p>
        Before clicking “Yes” in the process of cancellation application, you
        should carefully read the
        <em>Notes for Cancellation of CIFTIS Digital Platform Account</em>
        (hereinafter referred to as “Notes for Cancellation”).
      </p>
      <p>
        Please read carefully and fully understand the relevant provisions of
        the agreement, including:
      </p>
      <ol>
        <li>
          The agreed provisions related to liability exemption or limitation;
        </li>
        <li>Other important provisions underlined in bold.</li>
      </ol>
      <p>
        If you have any questions about this Notes for Cancellation, please
        consult our customer service at 400-693-0616.
      </p>
      <p>
        [Special Tips] When you fill in the information as prompted on the
        cancellation page, read and agree to the Notes for Cancellation as well
        as relevant terms and conditions, and complete all the cancellation
        procedures, it means that you have fully read, understood and accepted
        all the contents of the Notes for Cancellation. If you do not agree to
        any of the terms or conditions in the Notes for Cancellation, please
        stop the account cancellation procedure immediately.
      </p>
      <p>Dear users of CIFTIS Digital Platform,</p>
      <p>
        We hereby kindly remind you that
        <strong
          >your behavior of cancelling your account will cause much
          inconvenience to your after-sales rights protection; upon cancellation
          of your CIFTIS Digital Platform account, we will only remove your
          personal information from the CIFTIS Digital Platform system to keep
          it in a state that cannot be retrieved or accessed, or we will
          anonymize such information.</strong
        >
      </p>
      <ol>
        <li>
          If you still want to cancel your account, the account should meet all
          of the following conditions:
        </li>
      </ol>
      <p>
        (1)&nbsp; In the last month, there was no such sensitive operations as
        changing password or changing binding information on the account;
      </p>
      <p>
        (2)&nbsp; You voluntarily waive the assets in the account in the CIFTIS
        Digital Platform system, and have no auction deposits, nor arrears;
      </p>
      <p>
        (3)&nbsp; There are no uncompleted orders, services or other valid
        business in the account;
      </p>
      <p>
        (4)&nbsp; The account is free from any dispute, including the cases of
        complaining and being complained;
      </p>
      <p>
        (5)&nbsp; The account has been released from the authorized login or
        binding relationship with other websites and applications.
      </p>
      <ol>
        <li>
          The CIFTIS Digital Platform account cannot be restored once cancelled.
          Please back up all the information and data related to the CIFTIS
          Digital Platform account before operation. Please keep well the
          transaction vouchers, invoices and other documents related to the
          ordered products or services, otherwise, CIFTIS Digital Platform will
          not be able to assist you in querying or retrieving the above
          information.
        </li>
        <li>
          If your CIFTIS Digital Platform account is bound to a booth, you need
          to unbind it first;
        </li>
        <li>
          During cancellation of your CIFTIS Digital Platform account, if your
          CIFTIS Digital Platform account is involved in any dispute, including
          but not limited to complaint, report, legal proceedings, arbitration
          and investigation by competent state authorities, we reserve the right
          to terminate the cancellation of the CIFTIS Digital Platform account
          without your prior consent.
        </li>
        <li>
          <strong></strong>
          <strong
            >Upon cancellation of your CIFTIS Digital Platform account, you will
            not be able to retrieve any content or information related to your
            CIFTIS Digital Platform account, which includes but is not limited
            to:</strong
          >
        </li>
      </ol>
      <p>
        (1)&nbsp; You will not be able to log in and use the cancelled CIFTIS
        Digital Platform account;
      </p>
      <p>
        (2)&nbsp; The personal data and historical information (including but
        not limited to real-name information, message logging, order
        information) on the CIFTIS Digital Platform account will not be
        retrieved;
      </p>
      <p>
        (3)&nbsp; Any other interests acquired by you will be deemed to be
        waived by you and will no longer be usable. You understand and agree
        that we cannot assist you in restoring the aforementioned services.
        Before submitting your cancellation application, please be sure to find
        out the other relevant account information you need to unbind. For
        details, please contact our customer service.
      </p>
      <ol>
        <li>
          <strong></strong>
          <strong
            >The cancellation of this CIFTIS Digital Platform account does not
            represent a waiver or mitigation of the account operations and
            related responsibilities before the cancellation of this CIFTIS
            Digital Platform account.</strong
          >
        </li>
      </ol>
    </section>
    <section v-else>
      <p>更新日期：2022年8月24日<br />生效日期：2022年8月31日</p>
      <p>
        <strong
          >【特别提示】请仔细阅读《服贸会平台隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询。</strong
        >
      </p>
      <p>引言</p>
      <p>
        首都会展（集团）有限公司（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《服贸会平台隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。本政策将帮助您了解以下内容：
      </p>
      <p>1、适用范围</p>
      <p>2、我们收集您的信息的范围</p>
      <p>3、我们收集您的信息的方式</p>
      <p>4、我们如何共享、转让、公开披露您的个人信息</p>
      <p>5、我们如何保护和保存您的个人信息</p>
      <p>6、您如何管理个人信息</p>
      <p>7、未成年人信息的保护</p>
      <p>8、通知和修订</p>
      <p>9、如何联系我们</p>
      <p>
        <strong>本隐私政策与您所使用的我们的（或称</strong><strong>“</strong
        ><strong>服贸会平台</strong><strong>”</strong
        ><strong>）服务以及该服务所包括的各种业务功能（以下统称</strong
        ><strong>“</strong><strong>我们的产品与</strong><strong>/</strong
        ><strong>或服务</strong><strong>”</strong
        ><strong>）息息相关，希望您在使用我们的产品与</strong><strong>/</strong
        ><strong
          >或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与</strong
        ><strong>/</strong><strong>或服务，即意味着您同意本隐私政策</strong
        ><strong>(</strong><strong>含更新版本</strong><strong>)</strong
        ><strong
          >内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至</strong
        ><strong
          ><a
            href="mailto:service@ciftis.org.cn"
            data-mce-href="mailto:service@ciftis.org.cn"
            >service@ciftis.org.cn</a
          ></strong
        ><strong>或拨打我们的咨询热线</strong><strong>400-693-0616</strong
        ><strong>与我们联系</strong>
      </p>
      <p><strong>一、适用范围</strong></p>
      <p>
        1.1
        本隐私权政策适用于服贸会平台网站所有服务，包括在中国国际服务贸易交易会官网（域名为<a
          href="http://www.ciftis.org"
          data-mce-href="http://www.ciftis.org"
          >www.ciftis.org</a
        >）及服贸会平台客户端向您提供页面浏览、网站登录服务，以及通过服贸会平台网站向您提供的技术服务。
      </p>
      <p>
        1.2
        本隐私权政策不适用于其他第三方通过服贸会平台网站向您提供的服务（统称“第三方服务”）。您向该第三方服务提供者提供的信息不适用于本隐私政策，您在选择使用第三服务前应充分了解第三方服务的产品功能及隐私保护政策，再选择是否开通功能。
      </p>
      <p>
        1.3
        需要特别说明的是，作为服贸会平台的用户，若您利用我们的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定相应的隐私政策。
      </p>
      <p><strong>二、我们收集您的信息的范围</strong></p>
      <p>本隐私政策中涉及的个人信息包括：</p>
      <p>
        基本信息：您为完成服贸会平台账户的注册、管理后台、实名认证等，您提交的真实、合法、有效的个人姓名、国籍、性别、生日、联系电话号码、电子邮箱、个人职务、个人健康宝（Health
        Kit）小程序健康码状态；
      </p>
      <p>
        个人身份信息：您使用服贸会平台证件申请、参观预约及关联的防疫筛查等服务时，您提交身份证、护照、回乡证、台胞证等；
      </p>
      <p>网络身份标识信息：包括系统账号、密码、IP地址、邮箱地址；</p>
      <!-- <p>
        个人上网记录：网站浏览记录、软件使用记录、日志信息；用于为您提供内容推荐以及组委会进行数据统计分析。
      </p> -->
      <p>
        个人常用设备信息：包括硬件型号、操作系统类型、IDFA、Android
        ID、MAC地址在内的描述个人常用设备基本情况的信息；
      </p>
      <p>
        个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括：个人身份信息（包括身份证、护照、回乡证、台胞证）；网络身份识别信息（包括账户名、邮箱地址及与前述有关的密码）；其他信息（包括个人电话号码、手机号码、网页浏览记录）。
      </p>
      <p>
        <strong>三、</strong><strong> </strong
        ><strong>您可选择是否授权我们收集和使用您的个人信息的情形</strong>
      </p>
      <p>
        <strong>如果您不提供这些个人信息，您依然可以进行浏览我们的产品及</strong
        ><strong>/</strong><strong>或服务，但您可能无法使用我们的产品及</strong
        ><strong>/</strong><strong>或服务，主要包括：</strong>
      </p>
      <ol>
        <li>
          <strong>1.</strong
          ><strong
            >不提供手机号码，将无法进行账号注册；无法执行部分需要通过手机验证码以确认用户身份的操作，如找回密码、获取参会审核通知等。</strong
          >
        </li>
        <li>
          <strong>2.</strong
          ><strong
            >不进行个人实名认证（需要提供姓名、身份证或港澳台证件、护照号、面部照片采集）无法进行证件申请、参观预约或意向签约。</strong
          >
        </li>
        <li>
          <strong>3.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >时，您可以接收我们的消息推送，以便更及时的获取平台通知、洽谈消息、直播提醒、会议通知等。若您不开启此权限，您将无法获取最新数据。</strong
          >
        </li>
        <li>
          <strong>4.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >时，您需要允许联网来使用我们的产品和服务。若您不开启此权限，您将无法获取最新数据。</strong
          >
        </li>
        <li>
          <strong>5.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的扫一扫、云会议、洽谈间、实名认证功能时，您可以通过开通相机权限以便进行实时拍摄并上传图片。在需要人脸识别的场景下，则需要调用您的摄像头进行人脸的拍摄以允许我们获取您的照片进行实名认证以完成服贸会参观预约和入场，若您不开启此权限，您将无法使用图片相关的功能和参观预约，但不影响您使用其他服务。</strong
          >
        </li>
        <li>
          <strong>6.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的扫一扫、洽谈间、名片二维码功能时，您可以通过开通相册权限以便上传设备中的图片。若您不开启此权限，您将无法使用图片上传相关的功能，但不影响您使用其他服务。</strong
          >
        </li>
        <li>
          <strong>7.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的洽谈间、云会议服务时，您可以开启麦克风权限以允许我们获取您的语音内容，点击长按语音输入进行问题描述、发送语音信息及允许主持人录制视频会议内容。若您不开启此权限，您将无法使用语音输入相关的功能，但不影响您使用其他服务。</strong
          >
        </li>
        <li>
          <strong>8.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的扫一扫、洽谈间、云签约、云会议时，您可以通过开启存储权限使用或保存图片或文件。若您不开启此权限，您将无法使用与存储卡读取相关的功能，但不影响您使用其他服务。</strong
          >
        </li>
        <li>
          <strong>9.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的智能导航、智能客服功能时，您可以通过允许获取地理位置以便我们为您提供导航服务。若您不开启此权限，您将无法使用真实路线导航，但不影响您使用其他服务。</strong
          >
        </li>
        <li>
          <strong>10.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的智能导航功能、云会议时，您可以通过允许获取设备蓝牙权限提供室内导航服务。若您不开启此权限，您将无法室内导航相关的功能，但不影响您使用其他服务。</strong
          >
        </li>
        <li>
          <strong>11.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的智能客服、云会议功能时，您可以通过允许获取设备电话权限提供拨打电话服务。若您不开启此权限，您将无法使用拨打电话相关的功能，但不影响您使用其他服务。</strong
          >
        </li>
        <!-- <li>
          <strong>12.</strong><strong>当您使用</strong><strong>Android</strong
          ><strong>或</strong><strong>iOS</strong><strong>版本服贸会</strong
          ><strong>App</strong
          ><strong
            >中的云会议功能时，您可以通过允许获取设备通讯录权限提供查询通话列表服务。若您不开启此权限，您将无法使用拨打电话相关的功能，但不影响您使用其他服务。</strong
          >
        </li> -->
      </ol>
      <p>
        <strong>四、</strong><strong> </strong
        ><strong>我们收集您的信息的方式</strong>
      </p>
      <p><strong>4.1 </strong><strong>您申请成为服贸会平台会员</strong></p>
      <p>
        <strong>4.1.1 </strong
        ><strong
          >当您在服贸会平台网站创建服贸会平台账户时，我们通过您主动提交的姓名、您在中华人民共和国境内的手机号码，以及您设置的账号。</strong
        >您提交的手机号码用于您注册、登录、绑定账户、密码找回时接受验证码，并且作为您指定的联系方式之一，用来接受相关业务通知（如展会信息、服务通知等）。<strong
          >对于企业用户，还需要提供企业名称、所属行业和注册地址信息</strong
        >
      </p>
      <p>
        <strong>4.1.2 </strong
        ><strong
          >在您注册完成服贸会平台账户后，作为个人用户，您可以在预约参观的预约流程中进行实名认证，您在实名认证时需提供姓名、身份证件号码，对境内人员还将采集面部照片。作为企业用户，您可以在账户中心申请参展参会，并提供相应的信息，包括（</strong
        ><strong>1</strong
        ><strong>）联系信息（姓名、职务、联系电话、联系邮箱），（</strong
        ><strong>2</strong
        ><strong
          >）企业信息（企业名称、单位性质、社会信用代码、所属行业、注册地、公司类型、网址、单位介绍）；其中您提供的第（</strong
        ><strong>1</strong
        ><strong
          >）类企业信息，将用于组委会联系您沟通参展参会信息，以及向其他企业显示，以便进一步与您的企业进行沟通洽谈。您提交的这些信息仅用于中国国际服务贸易交易会（简称</strong
        ><strong>“</strong><strong>服贸会</strong><strong>”</strong
        ><strong
          >）参观预约，或企业参展参会申请。您若不提供这些信息，将不会影响您对服贸会平台其他服务的使用。</strong
        >
      </p>
      <p>
        <strong>4.1.3 </strong
        ><strong
          >您的账号下创建子用户时，需要收集子用户主体的姓名、手机号码、电子邮箱、国籍、性别、证件号、生日、职务信息、证件照。您提交的子用户个人信息视为您已经获得子账号主体的授权并提交子账号的上述信息。</strong
        >
      </p>
      <p>
        <strong>4.1.4 </strong
        ><strong
          >如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。</strong
        >
      </p>
      <p>
        <strong>4.1.5 </strong
        ><strong
          >如果您已经注册有服贸会平台账号的，您可利用前述账号登录服贸会平台网站。您通过服贸会平台账号登录服贸会平台网站的，您的服贸会平台注册账号的实名注册信息（姓名</strong
        ><strong>/</strong><strong>企业名称、国籍、身份证件号</strong
        ><strong>/</strong><strong>营业执照号、手机号</strong><strong>/</strong
        ><strong>邮箱）将同步至服贸会平台网站。</strong>
      </p>
      <p><strong>4.2 </strong><strong>您使用服贸会平台服务</strong></p>
      <p>
        <strong>4.2.1 </strong
        ><strong
          >在您使用服贸会平台的服务时，您通过您的账号提供您的真实身份信息以完成实名认证，在此过程中，您将提交您的姓名（单位主体名称）、身份证件号码（营业执照号码）、企业注册地区、企业性质、企业名称和营业执照注册号，企业联系人信息。</strong
        >
      </p>
      <p>
        <strong>4.2.2 </strong
        ><strong
          >我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置等软硬件特征信息）、设备所在位置相关信息（</strong
        ><strong>IP</strong
        ><strong
          >地址）。我们可能会将前面两类信息进行关联，以便我们能在不同设备上为您提供一致的服务。</strong
        >
      </p>
      <p>
        <strong>4.2.3 </strong
        ><strong
          >当您使用我们的网站或客户端提供的服务时，为识别账号异常状态、了解产品适配性、帮助主办商优化展会展品展示形式、直播效果，我们会自动收集您对我们服务的使用情况，作为有关网络日志保存。包括：</strong
        >
      </p>
      <p>
        <strong>设备信息：我们会根据您在软件安装及</strong><strong>/</strong
        ><strong
          >或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（包括您授权的</strong
        ><strong>GPS</strong><strong>位置以及</strong><strong>WLAN</strong
        ><strong>接入点、蓝牙和基站等传感器信息）。</strong>
      </p>
      <p>
        <strong
          >服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，例如您的搜索查询内容、</strong
        ><strong>IP</strong
        ><strong
          >地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</strong
        >
      </p>
      <p>
        <strong>4.2.4 </strong
        ><strong
          >请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做去标识化处理。</strong
        >
      </p>
      <p>
        <strong>4.2.5 </strong
        ><strong
          >用户账户的支持信息：基于您使用服贸会平台服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），我们将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。</strong
        >
      </p>
      <!-- <p>
        <strong
          >为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和您使用服贸会平台服务时的浏览使用信息，提取您的偏好特征，并基于特征标签产出间接人群画像，用于展示、推送信息和可能的商业广告。</strong
        >
      </p>
      <p>
        <strong
          >我们努力保障您的浏览体验。如果您不想接受我们给您发送的商业广告，您可通过短信提示回复退订或我们提供的其他方式进行退订或关闭。</strong
        ><strong
          >此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。</strong
        >
      </p> -->
      <p><strong>4.3 </strong><strong>Cookies 的使用。</strong></p>
      <p>
        <strong
          >为使您获得更轻松的访问体验，我们有时会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie
          是一种网络服务器存储在计算机或移动设备上的纯文本文件，其内容只能由创建它的服务器检索或读取。每个
          Cookie对您的网络浏览器或移动应用程序都是唯一的。Cookie
          通常包含标识符、站点名称以及一些号码和字符。借助于
          Cookie，网站能够记住用户的单次访问（使用会话
          Cookie）或多次访问（使用永久 Cookie）。</strong
        >
      </p>
      <p>
        <strong>4.4 </strong><strong>我们从第三方获得您个人信息的情形</strong>
      </p>
      <p>
        我们可能从第三方获取您授权共享的个人信息，并在您同意本隐私政策后，<strong
          >依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</strong
        >
      </p>
      <p>
        <strong>4.5 </strong
        ><strong
          >为便利采购商与主办商、参展商之间的沟通，企业采购商的员工、联系人或其他代表及个人采购商可在服贸会平台上通过在线会议、即时通讯、站内信、论坛留言等方式进行洽谈、询盘。如您希望使用这一功能，根据有关实名制的管理要求，您可能需要向我们提供真实姓名、个人身份信息（身份证号码、护照号码等）等信息，以便我们进行实名认证。</strong
        >
      </p>
      <p>
        <strong
          >对于上述附加服务，您可以选择不提供这些个人信息，但将影响您正常使用服贸会服务主要功能。</strong
        >
      </p>
      <p>
        <strong>4.6 </strong><strong>当您终止使用我们的产品与</strong
        ><strong>/</strong><strong>或服务时，或您使用我们的产品与</strong
        ><strong>/</strong
        ><strong
          >或服务之服务期届满后，我们将立即停止继续收集您的个人信息。</strong
        >
      </p>
      <p><strong>五、我们如何共享、转让、公开披露您的个人信息</strong></p>
      <p>5.1 共享</p>
      <p>
        5.1.1
        我们不会与其他任何公司、组织和个人共享您的个人信息，但以下情况除外：
      </p>
      <p>（1）事先获得您明确的同意或授权；</p>
      <p>
        （2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
      </p>
      <p>
        （3）在法律法规允许的范围内，为维护我们、我们的关联方或合作伙伴、您或其他服贸会平台用户或社会公众利益、财产或安全免遭损害而有必要提供；
      </p>
      <p>
        （4）只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；
      </p>
      <p>（5）应您需求为您处理您与他人的纠纷或争议；</p>
      <p>
        （6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
      </p>
      <p>（7）基于符合法律法规的社会公共利益而使用。</p>
      <p>
        5.1.2
        我们可能会将您的个人信息与我们的关联方共享，以保障为您提供的服务顺利完成。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
      </p>
      <p>
        5.1.3
        我们可能会委托合作伙伴来提供某些服务，而需要和合作伙伴共享您的用户信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。目前我们的合作伙伴包括：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。
      </p>
      <p>
        5.1.4
        为了使您能够使用上述专业服务，我们的客户端（服贸会平台APP）中会嵌入授权合作伙伴的软件工具开发包（“SDK”）或其他类似的应用程序。
      </p>
      <p>
        为保障服贸会相关使用目的的实现和应用的安全稳定运行，我们会接入由第三方提供的软件开发包（SDK）实现该目的，请查看<a
          class="sdk_link"
          target="_blank"
          href="https://m-console.ciftis.org/rule/sharing"
          >《个人信息共享清单》</a
        >
      </p>
      <p>Android版本服贸会平台APP涉及嵌入第三方SDK的情形如下：</p>
      <table class="confluenceTable">
        <tbody class="">
          <tr class="">
            <td class="confluenceTd">
              <p><strong>使用场景描述</strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>必须采集个人信息字段</strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>授权机构主体名称</strong></p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>微信分享</p></td>
            <td class="confluenceTd"><p>用户昵称、用户唯一标识</p></td>
            <td class="confluenceTd">
              <p>深圳市腾讯计算机系统有限公司</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>中国银行线上收银台</p></td>
            <td class="confluenceTd"><p>设备类型、制造商</p></td>
            <td class="confluenceTd">
              <p>中国银行</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>支付宝支付</p></td>
            <td class="confluenceTd"><p>设备类型、制造商</p></td>
            <td class="confluenceTd">
              <p>支付宝（中国网络技术有限公司）</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>微信支付</p></td>
            <td class="confluenceTd"><p>设备类型、制造商</p></td>
            <td class="confluenceTd">
              <p>腾讯科技（深圳）有限公司</p>
            </td>
          </tr>
          <!-- <tr class="">
            <td class="confluenceTd"><p>华为消息推送</p></td>
            <td class="confluenceTd">
              <p>设备唯一标识码、系统版本、设备型号、设备厂商</p>
            </td>
            <td class="confluenceTd"><p>华为技术有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>魅族消息推送</p></td>
            <td class="confluenceTd">
              <p>设备唯一标识码、系统版本、设备型号、设备厂商</p>
            </td>
            <td class="confluenceTd"><p>珠海市魅族科技有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>小米消息推送</p></td>
            <td class="confluenceTd">
              <p>设备唯一标识码、系统版本、设备型号、设备厂商</p>
            </td>
            <td class="confluenceTd"><p>小米科技有限责任公司</p></td>
          </tr> -->
          <tr class="">
            <td class="confluenceTd"><p>京东消息推送</p></td>
            <td class="confluenceTd">
              <p>手机状态、<span>ROM</span>版本、厂商名称、手机型号</p>
            </td>
            <td class="confluenceTd"><p>北京京东世纪贸易有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>京东子午线</p></td>
            <td class="confluenceTd">
              <p>
                设备唯一标识码、设备厂商、设备型号、系统版本、设备运行时间、用户访问<span>IP</span>地址、操作系统、浏览器类型、浏览器版本、浏览器唯一号、已安装APP信息
              </p>
            </td>
            <td class="confluenceTd"><p>北京京东世纪贸易有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>京东鹰眼</p></td>
            <td class="confluenceTd">
              <p>
                设备唯一标识码、设备厂商、设备型号、AndroidId、MAC地址、系统版本、存储空间、内存大小、网络类型、设备运行时间、应用内部页面访问记录、已安装APP信息
              </p>
            </td>
            <td class="confluenceTd"><p>北京京东世纪贸易有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>云会议</p></td>
            <td class="confluenceTd">
              <p>
                用户昵称、设备唯一标识码、系统版本、设备型号、设备厂商、<span>IP</span>地址、<span
                  >Zoom SDK</span
                >、MAC地址、设备属性、WIFI信息、已安装APP信息
              </p>
            </td>
            <td class="confluenceTd"><p>北京云联信通科技有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd">
              <p>
                视频直播<span>_</span>科大讯飞<span>SDK</span>语音识别等功能
              </p>
            </td>
            <td class="confluenceTd">
              <p>
                用户昵称、用户唯一标识、唯一设备识别码、AndroidId、MAC地址、WIFI信息、已安装APP信息
              </p>
            </td>
            <td class="confluenceTd"><p>科大讯飞股份有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>智能导航</p></td>
            <td class="confluenceTd">
              <p>用户昵称、用户唯一标识、MAC地址、WIFI信息</p>
            </td>
            <td class="confluenceTd"><p>北京蜂鸟视图科技有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>洽谈间</p></td>
            <td class="confluenceTd">
              <p>
                用户唯一标识、用户组织标识、用户身份标识、会话标识、洽谈入口来源、MAC地址、WIFI信息
              </p>
            </td>
            <td class="confluenceTd">
              <p>北京沃东天骏信息技术有限公司</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>OPPO推送</p></td>
            <td class="confluenceTd">
              <p>唯一设备识别码、运营商信息</p>
            </td>
            <td class="confluenceTd">
              <p>OPPO广东移动通信有限公司</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>小米推送</p></td>
            <td class="confluenceTd">
              <p>唯一设备识别码、运营商信息</p>
            </td>
            <td class="confluenceTd">
              <p>小米科技有限责任公司</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>腾讯TBS浏览器</p></td>
            <td class="confluenceTd">
              <p>设备型号、操作系统、CPU类型、版本号、WIFI状态</p>
            </td>
            <td class="confluenceTd">
              <p>深圳市腾讯计算机系统有限公司</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>腾讯Bugly异常上报</p></td>
            <td class="confluenceTd">
              <p>硬件设备型号、操作系统及版本、已安装APP信息</p>
            </td>
            <td class="confluenceTd">
              <p>深圳市腾讯计算机系统有限公司</p>
            </td>
          </tr>
          <!-- <tr class="">
            <td class="confluenceTd"><p>OPPO推送</p></td>
            <td class="confluenceTd">
              <p>设备唯一标识码、系统版本、设备型号、设备厂商</p>
            </td>
            <td class="confluenceTd"><p>OPPO广东移动通信有限公司</p></td>
          </tr> -->
        </tbody>
      </table>
      <p>IOS版本服贸会平台APP涉及嵌入第三方SDK的情形如下：</p>
      <table class="confluenceTable">
        <tbody class="">
          <tr class="">
            <td class="confluenceTd">
              <p><strong>使用场景描述</strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>必须采集个人信息字段</strong></p>
            </td>
            <td class="confluenceTd">
              <p><strong>授权机构主体名称</strong></p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>微信分享</p></td>
            <td class="confluenceTd"><p>用户昵称、用户唯一标识</p></td>
            <td class="confluenceTd">
              <p>深圳市腾讯计算机系统有限公司</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>中国银行线上收银台</p></td>
            <td class="confluenceTd"><p>设备类型、制造商</p></td>
            <td class="confluenceTd">
              <p>中国银行</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>支付宝支付</p></td>
            <td class="confluenceTd"><p>设备类型、制造商</p></td>
            <td class="confluenceTd">
              <p>支付宝（中国网络技术有限公司）</p>
            </td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>微信支付</p></td>
            <td class="confluenceTd"><p>设备类型、制造商</p></td>
            <td class="confluenceTd">
              <p>腾讯科技（深圳）有限公司</p>
            </td>
          </tr>
          <!-- <tr class="">
            <td class="confluenceTd"><p>京东消息推送</p></td>
            <td class="confluenceTd">
              <p>手机状态、<span>ROM</span>版本、厂商名称、手机型号</p>
            </td>
            <td class="confluenceTd"><p>北京京东世纪贸易有限公司</p></td>
          </tr> -->
          <tr class="">
            <td class="confluenceTd"><p>京东子午线</p></td>
            <td class="confluenceTd">
              <p>
                设备唯一标识码、设备厂商、设备型号、系统版本、设备运行时间、用户访问<span>IP</span>地址、操作系统、浏览器类型、浏览器版本、浏览器唯一号
              </p>
            </td>
            <td class="confluenceTd"><p>北京京东世纪贸易有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>京东鹰眼</p></td>
            <td class="confluenceTd">
              <p>
                设备唯一标识码、设备厂商、设备型号、系统版本、存储空间、内存大小、网络类型、设备运行时间、应用内部页面访问记录
              </p>
            </td>
            <td class="confluenceTd"><p>北京京东世纪贸易有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>云会议</p></td>
            <td class="confluenceTd">
              <p>
                用户昵称、设备唯一标识码、系统版本、设备型号、设备厂商、<span>IP</span>地址、<span
                  >Zoom SDK</span
                >
              </p>
            </td>
            <td class="confluenceTd"><p>北京云联信通科技有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd">
              <p>视频直播<span>_</span>科大讯飞语音识别服务</p>
            </td>
            <td class="confluenceTd"><p>用户昵称、用户唯一标识</p></td>
            <td class="confluenceTd"><p>科大讯飞股份有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>智能导航</p></td>
            <td class="confluenceTd"><p>用户昵称、用户唯一标识</p></td>
            <td class="confluenceTd"><p>北京蜂鸟视图科技有限公司</p></td>
          </tr>
          <tr class="">
            <td class="confluenceTd"><p>洽谈间</p></td>
            <td class="confluenceTd">
              <p>
                用户唯一标识、用户组织标识、用户身份标识、会话标识、洽谈入口来源
              </p>
            </td>
            <td class="confluenceTd">
              <p>北京沃东天骏信息技术有限公司</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        5.1.5
        对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。为了保障数据在第三方安全可控，我们推出了云鼎服务，在云端提供安全可靠的数据使用和存储环境，确保用户数据的安全性。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。
      </p>
      <p>
        5.1.6
        为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护您或其他服贸会平台客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过,这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。
      </p>
      <p>
        5.1.7 <strong>关于自启动</strong> <br />
        为了让您体验APP消息离线提醒功能，更全面体验APP功能，提供更优质的服务，在您同意本隐私政策后，APP在必要时，会开启启动或关联启动功能。<br />
        集成推送消息自启动服务用于提高消息推送通达度。<br />
        目的：能及时收到应用聊天功能其他人发送的消息。<br />
        方式：集成小米推送sdk，可参照第三方sdk列表中小米推送描述。<br />
        范围：仅用于相应的功能。
      </p>
      <p>5.2 转让</p>
      <p>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </p>
      <p>5.2.1事先获得您明确的同意或授权；</p>
      <p>
        5.2.2根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
      </p>
      <p>
        5.2.3符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
      </p>
      <p>
        5.2.4在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。
      </p>
      <p>5.3 公开披露</p>
      <p>
        我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
      </p>
      <p>
        <strong>5.3.1</strong
        ><strong
          >根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</strong
        >
      </p>
      <p>
        <strong>5.3.2</strong
        ><strong
          >根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</strong
        >
      </p>
      <p><strong>六、我们如何保护和保存您的个人信息</strong></p>
      <p>
        6.1 我们保护您个人信息的技术与措施
        我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
      </p>
      <p>
        6.1.1 数据安全技术措施
        我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。
        我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。我们采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内多种数据脱敏技术增强个人信息在使用中安全性。我们采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。我们采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。
      </p>
      <p>6.1.2为保护个人信息采取的其他安全措施</p>
      <p>
        我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。安全认证和服务：我们存储您个人数据的底层云技术取得了数据中心联盟颁发的“可信云”认证，通过了公安部安全等级保护三级认证，同时还获得了ISO27001认证。
        加强安全意识：我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
      </p>
      <p>
        6.1.3
        我们仅允许有必要知晓这些信息的我们及我们关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我们的合作关系
      </p>
      <p>
        6.1.4
        我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
      </p>
      <p>
        6.1.5
        互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。
      </p>
      <p>
        6.1.6
        互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
      </p>
      <p>
        6.1.7 安全事件处置
        在通过服贸会平台网站与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。
      </p>
      <p>
        为应对个人信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </p>
      <p>
        6.1.8
        如果您对我们的个人信息保护有任何疑问，可通过本政策最下方约定的联系方式联系我们。如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即通过本政策最下方【如何联系我们】约定的联系方式联络我们，以便我们采取相应措施。
      </p>
      <p>6.2 您个人信息的保存</p>
      <p>
        6.2.1
        您的个人信息将全被存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
      </p>
      <p>
        6.2.2关于您注销账户的方式以及您应满足的条件，请详见《服贸会平台账户注销须知》。
        您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。<strong
          >请您注意，当您成功申请注销服贸会平台账户后，我们将在您提出申请的</strong
        ><strong>3</strong
        ><strong
          >个工作日内完成对您的账户注销审核，审核通过后，我们将对您的个人信息进行删除。</strong
        >
      </p>
      <p>
        6.2.3
        如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
      </p>
      <p><strong>七、您如何管理您的个人信息</strong></p>
      <p>
        我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
      </p>
      <p>
        7.1
        您可以登录服贸会平台网站管理后台查询、管理（变更、删除）使用服贸会平台服务时而提交的人员信息。
      </p>
      <p>
        7.2
        如果您需要变更您服贸会平台账户的实名认证信息，您需通过工单、电话等方式联系我们，按照我们的操作文档进操作；如您需变更通过服贸会平台账号提交的实名认证信息的，您需到原账号注册的网站进行变更。
      </p>
      <p>7.3 在以下情形中，您可以向我们提出删除用户信息的请求：</p>
      <p>7.3.1.如果我们处理用户信息的行为违反法律法规；</p>
      <p>7.3.2 如果我们收集、使用您的用户信息，却未征得您的明确同意；</p>
      <p>7.3.3 如果我们处理个人信息的行为严重违反了与您的约定；</p>
      <p>7.3.4 您行使撤回同意权和拒绝权时。</p>
      <p>7.4 改变您授权同意的范围或撤回您的授权</p>
      <p>
        您可以通过工单、电话等方式联系我们，改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。
      </p>
      <p>
        请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </p>
      <!-- <p>
        7.5
        为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能将来自服贸会平台网站某项服务的用户信息与来自其他项服务的信息结合起来，做出特征模型并进行用户画像，向您展示、推送信息，包括但不限于关于服贸会产品的新闻以及市场活动信息、合作第三方的推广信息，或其他您可能感兴趣的内容。&nbsp;<strong
          >如果您不想接收我们给您发送的商业性电子信息，您随时可通过以下方式取消：</strong
        >
      </p>
      <p>
        （1）我们会基于您的个人信息与第三方的平台或媒体（“平台”）合作向您推荐个性化的展品。这些个人信息包括诸如在本网站的购物情况、访问本网站关联公司网站的情况。平台仅向我们提供了展示商品的窗口，窗口内容的链接是服贸会平台站内的个性化商品展示信息，由我们进行管理，因此我们不会向广告商提供您的任何的个人信息。如您不愿意接受我们在单个平台上的推荐服务，请联系平台进行关闭。您知晓并理解平台是自主经营的实体，我们无法对其进行管理。
      </p>
      <p>
        （2）为了保护您的隐私，我们不会以任何方式和途径向您推送涉及宗教信仰、性、疾病等相关敏感内容的促销或商品信息给您。
      </p> -->
      <p><strong>八、未成年人的个人信息保护</strong></p>
      <p>
        8.1
        我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。我们将根据国家相关法律法规的规定保护未成年人的个人信息。
      </p>
      <p>
        8.2
        对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
      </p>
      <p>
        8.3
        如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
      </p>
      <p><strong>九、通知和修订</strong></p>
      <p>
        9.1
        为给您提供更好的服务以及随着我们业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在服贸会平台网站上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问服贸会平台以便及时了解最新的隐私政策。
      </p>
      <p>
        9.2
        对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。
        本政策所指的重大变更包括但不限于：（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；（3）个人信息共享、转让或公开披露的主要对象发生变化；（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；（6）个人信息安全影响评估报告表明存在高风险时。
      </p>
      <p>9.3 我们还会将本隐私政策的旧版本存档，供您查阅。</p>
      <p><strong>十、如何联系我们</strong></p>
      <p>
        10.1
        如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过发送邮件至service@<a
          href="http://ciftis.org.cn"
          data-mce-href="http://ciftis.org.cn"
          >ciftis.org.cn</a
        >或拨打我们的客服电话400-693-0616等方式与我们联系。
      </p>
      <p>
        10.2 我们设立了个人信息保护专员，您可以通过发送邮件至service@<a
          href="http://ciftis.org.cn"
          data-mce-href="http://ciftis.org.cn"
          >ciftis.org.cn</a
        >的方式与其联系。
      </p>
      <p>
        10.3
        一般情况下，我们将在三十天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。
      </p>
      <p><br /></p>
      <p><strong>附件：《服贸会系统账号注销须知》</strong></p>
      <p>服贸会系统账号注销须知内容：</p>
      <p>注销本账号后，您将放弃以下权益和资产</p>
      <ol>
        <li>1.账号信息无法恢复</li>
        <li>2.无法使用账号原验证手机或邮箱登陆服贸会系统服务</li>
        <li>3.解除与第三方授权或绑定关系</li>
      </ol>
      <p>
        您理解并同意，服贸会系统无法重新恢复前述服务，您注销账号的行为会给您的售后维权带来诸多不便，请您在操作之前，确保您的账号无任何纠纷，并自行备份服贸会系统相关的所有信息和数据，下载并保存好订单产品和服务的交易凭证、电子合同等资料，否则服贸会系统将无法协助您获得上述内容。
      </p>
      <p><strong>《服贸会系统账号注销须知》</strong></p>
      <p>
        您在申请注销流程中点击同意前，应当认真阅读《服贸会系统账号注销须知》（以下称“《注销须知》”）。
      </p>
      <p>请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</p>
      <p>1、与您约定免除或限制责任的条款；</p>
      <p>2、其他以粗体下划线标识的重要条款。</p>
      <p>
        如您对本《注销须知》有任何疑问，可拨打我们的客服电话400-693-0616联系客服咨询。
      </p>
      <p>
        【特别提示】当您按照注销页面提示填写信息、阅读并同意本《注销须知》及相关条款与条件且完成全部注销程序后，即表示您已充分阅读、理解并接受本《注销须知》的全部内容。阅读本《注销须知》的过程中，如果您不同意相关任何条款和条件约定，请您立即停止账号注销程序。
      </p>
      <p>亲爱的服贸会系统用户：</p>
      <p>
        我们在此善意地提醒您，<strong
          >您注销账号的行为会给您的售后维权带来诸多不便，且注销服贸会系统账号后，您的个人信息我们只会在服贸会系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。</strong
        >
      </p>
      <ol>
        <li>1.如果您仍执意注销账号，您的账号需同时满足以下条件：</li>
      </ol>
      <p>
        （1）在最近一个月内，账号没有进行更改密码、更改绑定信息等敏感操作；
      </p>
      <p>（2）自愿放弃账号在服贸会系统中的资产，无拍卖保证金、无欠款；</p>
      <p>（3）账号内无未完成的订单、服务或其他有效业务；</p>
      <p>（4）账号无任何纠纷，包括投诉举报或被投诉举报；</p>
      <p>（5）账号已经解除与其他网站、其他APP的授权登录或绑定关系。</p>
      <ol>
        <li>
          1.服贸会系统账号一旦被注销将不可恢复，请您在操作之前自行备份服贸会系统账号相关的所有信息和数据。请您保存好订单商品和服务的交易凭证、票据等资料，服贸会系统将无法协助您查询或找回上述信息。
        </li>
        <li>2.如果您的服贸会系统账号绑定展台，您需先解除相关绑定；</li>
        <li>
          3.在服贸会系统账号注销期间，如果您的服贸会系统账号涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止本系统账号的注销而无需另行得到您的同意。
        </li>
        <li>
          <strong>4.</strong
          ><strong
            >注销服贸会系统账号，您将无法找回您服贸会系统中账户相关的任何内容或信息，包括但不限于：</strong
          >
        </li>
      </ol>
      <p>（1）您将无法登录、使用本服贸会系统账号；</p>
      <p>
        （2）本服贸会系统账号的个人资料和历史信息（包括但不限于实名信息、消息记录、订单信息等）都将无法找回；
      </p>
      <p>
        （3）您曾获得的其他权益视为您自行放弃，将无法继续使用。您理解并同意，我们无法协助您重新恢复前述服务。请您在提交注销账号申请前，务必先了解您须解绑的其他相关账号信息，具体可与我们的客服联系。
      </p>
      <ol>
        <li>
          <strong>1.</strong
          ><strong
            >注销本服贸会系统账号并不代表账号注销前的账号行为和相关责任得到豁免或减轻。</strong
          >
        </li>
      </ol>
    </section>
  </div>
</template>

<script>
import { getPolicyDetailById } from '@/api/newscenter-api'
import { getLang } from '@/utils'

export default {
  data() {
    return {
      lang: 'zh-CN',
      remoteContent: '',
      isLoading: true
    }
  },
  created() {
    const detectedLang = getLang()
    if (detectedLang) {
      this.lang = detectedLang
    }
    this.loadContent()
  },
  methods: {
    async loadContent() {
      const {
        VUE_APP_PRIVACY_ID = '',
        VUE_APP_PRIVACY_EN_ID = ''
      } = process.env
      const targetId =
        this.lang === 'en-US'
          ? VUE_APP_PRIVACY_EN_ID || VUE_APP_PRIVACY_ID
          : VUE_APP_PRIVACY_ID

      if (!targetId) {
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        const response = await getPolicyDetailById(targetId)
        const richText = this.extractRichText(response)
        if (richText && richText.trim().length > 0) {
          this.remoteContent = richText
        }
      } catch (error) {
        // Swallow errors to fall back to the bundled default content.
      } finally {
        this.isLoading = false
      }
    },
    extractRichText(response) {
      const result = response && response.result
      if (!result) {
        return ''
      }

      const container = result.content || result.data
      if (container && container.richText) {
        return container.richText.replace(
          /text-wrap-mode:\s*nowrap/g,
          'text-wrap-mode:wrap'
        )
      }

      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep table {
  border-collapse: collapse;
}
@media screen and (max-width: 800px) {
  .privacy {
    padding: 0.4rem;
    background: #fff;
    color: #333;
    font-size: 0.24rem;
    line-height: 0.4rem;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    word-break: break-word;
    overflow-wrap: break-word;
    h2,
    h3,
    h4,
    h5,
    p,
    li,
    th,
    td {
      font-size: 0.24rem;
      line-height: 0.4rem;
    }

    h2,
    h3,
    h4 {
      margin: 0 0 0.24rem;
      font-weight: bold;
    }

    p {
      margin: 0 0 0.24rem;
    }

    li {
      margin: 0 0 0.24rem;
    }
    table {
      margin: 0 0 0.24rem;
      border-collapse: collapse;
      display: block;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    th {
      padding: 0 0.08rem;
      border-spacing: 0;
      border: 1px solid #ccc;
      background: #f0f0f0;
      white-space: normal;
      word-break: break-word;
    }
    td {
      padding: 0 0.08rem;
      border-spacing: 0;
      border: 1px solid #ccc;
      background: #fff;
      white-space: normal;
      word-break: break-word;
    }
  }
}
@media screen and (min-width: 800px) {
  .privacy {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    color: #333;
    font-size: 14px;
    line-height: 28px;
    overflow-x: auto;
    overflow-wrap: break-word;
    word-break: break-word;

    h2,
    h3,
    h4 {
      font-weight: bold;
      font-size: 12px;
      margin: 0 0 12px;
    }

    p {
      margin: 0 0 12px;
    }

    li {
      margin: 0 0 12px;
    }
    table {
      margin: 0 0 12px;
      border-collapse: collapse;
      overflow-x: auto;
    }

    th {
      padding: 6px 4px;
      border-spacing: 0;
      border: 1px solid #ccc;
      background: #f0f0f0;
      line-height: 20px;
      white-space: normal;
      word-break: break-word;
    }
    td {
      padding: 6px 4px;
      border-spacing: 0;
      border: 1px solid #ccc;
      background: #fff;
      line-height: 20px;
      white-space: normal;
      word-break: break-word;
    }
  }
}

.sdk_link {
  color: blue;
}
</style>
